<template>
  <div>
    <div style="float: right;">
      <multi-select
        :select-options="metrics"
        size="sm"
        btn-class="rounded-0"
        :options="{ multi: false }"
        btn-label="Metrics"
        align="right"
        v-model="activeMetrics"
      />
    </div>
    <div class="wrapper w-100"></div>
    <chart-stats
      :type="graphType"
      :active-metrics="activeMetrics"
      show-legend
      :data="sortedData"
      :pie-formatter="formatter"
      :map-formatter="formatter"
      :line-formatter="formatter"
    />
  </div>
</template>

<script>
import ChartStats from './ChartStats.vue';
import { sortDate } from '@/components/TableStats/sort.js';
import groupBy from 'lodash.groupby';
import * as formatters from '@/utils/formatters.js';

export default {
  props: {
    groups: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    metrics: {
      type: Array,
      required: true
    }
  },

  components: {
    ChartStats
  },

  data() {
    return {
      activeMetrics: [this.metrics[0]]
    };
  },

  computed: {
    graphType() {
      let primaryGroup = this.groups[0].key;

      if (primaryGroup === 'date') {
        return 'line';
      } else if (primaryGroup === 'countryId') {
        return 'map';
      } else {
        return 'pie';
      }
    },
    pieChartData() {
      if (this.graphType !== 'pie') return null;
      if (!this.groups[0]) return [];
      return this.reduceDublicatesByField(this.data, this.groups[0].key).map(
        el => {
          return {
            ...el,
            key: el[this.groups[0].key]
          };
        }
      );
    },
    mapChartData() {
      if (this.graphType !== 'map') return null;
      if (!this.groups[0]) return [];
      return this.reduceDublicatesByField(this.data, this.groups[0].key).map(
        el => {
          return {
            ...el,
            key: el[this.groups[0].key],
            name: el[this.groups[0].key]
          };
        }
      );
    },
    sortedData() {
      const hasHours = this.groups.find(el => el.key === 'hour');
      const hasDate = this.groups.find(el => el.key === 'date');

      let unsorted =
        hasHours || hasDate ? this.proccedDateTimeData() : this.data;

      if (this.graphType === 'line') {
        return sortDate(unsorted, 'date', 'asc');
      } else if (this.graphType === 'pie') {
        return this.pieChartData;
      } else {
        return this.mapChartData;
      }
    },
    formatter() {
      const formaterName =
        this.activeMetrics[0].valueTotal + this.activeMetrics[0].valueType;

      return formatters.default[formaterName.toLowerCase()];
    }
  },

  methods: {
    isAverage(el) {
      const type = el.toLowerCase();
      const needles = ['ctr', 'cpm', 'cpc'];
      return needles.some(needle => type.indexOf(needle) > -1);
    },
    reduceDublicatesByField(data, field) {
      const groupForReduce = groupBy(data, field);
      return Object.keys(groupForReduce).map(group => {
        return groupForReduce[group].reduce((result, current, index) => {
          const isLastIteration = index + 1 === groupForReduce[group].length;
          Object.keys(current).forEach(el => {
            result[el] = isNaN(result[el])
              ? current[el]
              : result[el] + current[el];

            if (isLastIteration && this.isAverage(el)) {
              result[el] = result[el] / groupForReduce[group].length;
            }
          });
          return result;
        }, {});
      });
    },
    proccedDateTimeData() {
      return this.data.map(el => {
        return {
          ...el,
          date: el.hour
            ? new Date(el.date).setHours(el.hour)
            : +new Date(el.date)
        };
      });
    }
  }
};
</script>
